//
//
//
//
//
//
//
//
//
//

export default {
  name: 'yo-button',
  props: {
    btnType: {
      type: String,
      default: 'button'
    },
    btnName: {
      type: String,
      default: '确定'
    },
    btnSize: {
      type: String,
      default: 's'
    },
    btnClass: {
      type: Object
    },
    btnStyle: {
      //可通用直接用一个变量设置样式
      type: Object,
      default: function () {
        return {
          backgroundColor: '#ff5775',
          color: '#ffffff'
        };
      }
    },
    btnColor: {
      type: Object,
      default: function () {
        return {
          backgroundColor: '#ff5775',
          color: '#ffffff'
        };
      }
    }
  },
  data() {
    return {
      touchable: true
    };
  },
  methods: {
    onConfirm: async function () {
      //                console.log('ready to emit somthing..')
      this.touchable = false;
      const res = await this.$emit('on-confirm');
      if (res) {
        this.touchable = true;
        //                    console.log('可点击。。。')
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/yoButton.vue